import { useState } from "react";
import { Link } from "react-router-dom";
import Dashboard from "../dashboard";
import DMT from "../pages/report/dmt";
import BBPS from "../pages/report/bbps";
import VerificationReport from "../pages/report/verificationreport";
import RechargeReport from "../pages/report/rechargereport";
import LicReport from "../pages/report/licreport";
import CmsReport from "../pages/report/cmsreport";
import AepsReport from "../pages/report/aepsreport";
import WalletToWalletReport from "../pages/report/wallettowalletreport";
import SettlementReport from "../pages/report/settlementreport";
import AccountStatementReport from "../pages/report/accountstatementreport";
import RefundPendigReport from "../pages/report/refundpendingreport";

function Sidebar() {
    const [openMenus, setOpenMenus] = useState({
        transfer: false,
        withdrawal: false,
        utility: false,
        other: false,
        ledger: false,
    });

    const toggleMenu = (menuKey) => {
        setOpenMenus((prev) => {
        const updated = {};
        for (const key in prev) {
            updated[key] = key === menuKey ? !prev[key] : false;
        }
        return updated;
        });
    };

    return (
      <div
      className="adminuiux-sidebar"
      style={{
          backgroundImage: "linear-gradient(to bottom, white, rgb(0 168 243))",
          top: "85px"
      }}
  >
      <div
          className="adminuiux-sidebar-inner"
          style={{
              backgroundImage: "linear-gradient(to bottom, white, rgb(0 168 243))"
          }}
      >
          <div className="px-3 not-iconic mt-3">
              <div className="row">
                  <div className="col align-self-center">
                      <h6 className="fw-medium">Main Menu</h6>
                  </div>
                  <div className="col-auto">
                      <a
                          className="btn btn-link btn-square"
                          data-bs-toggle="collapse"
                          data-bs-target="#usersidebarprofile"
                          aria-expanded="false"
                          role="button"
                          aria-controls="usersidebarprofile"
                      >
                          <i data-feather="user" />
                      </a>
                  </div>
              </div>
              <div className="text-center collapse" id="">
                  <figure className="avatar avatar-100 rounded-circle coverimg my-3">
                      <img src="/images/user-6.jpg" alt="" />
                  </figure>
                  <h5 className="mb-1 fw-medium">JUHI</h5>
                  <p className="small">shahjuhi319@gmail.com</p>
              </div>
          </div>
          <ul className="nav flex-column menu-active-line" style={{ padding: 0 }}>
              <li className="nav-item fw-500">
                  <span className="nav-link">
                      <i className="menu-icon bi bi-columns-gap" />{" "}                      
                      <Link to="/dashboard" className="nav-link" exact component={Dashboard}> <span className="menu-name">Dashboard</span> </Link>
                  </span>
              </li>
              <li className="nav-item fw-500 dropdown">
                  <a
                      href="#"
                      className="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      onClick={() => toggleMenu("transfer")}
                  >
                      <i className="menu-icon bi bi-bar-chart-line" />{" "}
                      <span className="menu-name">Transfer Reports</span>
                  </a>
                  {openMenus.transfer && (
                  <div className='dropdown-menu show' style={{position: "absolute", inset: "0px auto auto 0px", margin: "0px 25px", transform: "translate(0px, 48px)"}}>
                      <div className="nav-item">
                        <Link to="/dmt-report" className="nav-link" exact component={DMT}>                              
                              <span className="menu-name">&nbsp;&nbsp;DMT Report</span>
                          </Link>
                      </div>
                      <div className="nav-item">
                        <Link to="/verification-report" className="nav-link" exact component={VerificationReport}>
                              {" "}
                              <span className="menu-name">&nbsp;&nbsp;Verification Report</span>
                          </Link>
                      </div>
                      <div className="nav-item">
                          <span className="nav-link">                              
                              <span className="menu-name">&nbsp;&nbsp;Credit Card Report</span>
                          </span>
                      </div>                            
                  </div>
                  )}
              </li>
              <li className="nav-item fw-500 dropdown">
                  <a
                      href="#"
                      className="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      onClick={() => toggleMenu("withdrawal")}
                  >
                      <i className="menu-icon bi bi-piggy-bank" />{" "}
                      <span className="menu-name">Withdrawal Report</span>
                  </a>
                  {openMenus.withdrawal && (
                  <div className='dropdown-menu show' style={{position: "absolute", inset: "0px auto auto 0px", margin: "0px 25px", transform: "translate(0px, 48px)"}}>
                      <div className="nav-item">
                          <Link to="/aeps-report" className="nav-link" exact component={AepsReport}>
                              <span className="menu-name">&nbsp;&nbsp;AEPS Report</span>
                          </Link>
                      </div>
                      {/*<div className="nav-item">
                      <Link to="#" className="nav-link"> <span className="menu-name">Matm Report</span> </Link>
                      </div>
                      <div className="nav-item">
                      <Link to="#" className="nav-link"> <span className="menu-name">AEPS Settlement Report</span> </Link>
                      </div> */}
                  </div>
                  )}
              </li>
              <li className="nav-item fw-500 dropdown">
                  <a
                      href="#"
                      className="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      onClick={() => toggleMenu("utility")}
                  >
                      <i className="menu-icon bi bi-layers" />{" "}
                      <span className="menu-name">Utility Reports</span>
                  </a>
                  {openMenus.utility && (
                  <div className='dropdown-menu show' style={{position: "absolute", inset: "0px auto auto 0px", margin: "0px 25px", transform: "translate(0px, 48px)"}}>
                      <div className="nav-item">
                          <Link to="/recharge-report" className="nav-link" exact component={RechargeReport}>
                              <span className="menu-name">&nbsp;&nbsp;Recharge Report</span>
                          </Link>
                      </div>
                      <div className="nav-item">
                          <Link to="/billpayment-report" className="nav-link" exact component={RechargeReport}>
                              <span className="menu-name">&nbsp;&nbsp;Bill Payment Report</span>
                          </Link>
                      </div>
                  </div>
                  )}
              </li>
              <li className="nav-item fw-500 dropdown">
                  <a
                      href="#"
                      className="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      onClick={() => toggleMenu("other")}
                  >
                      <i className="menu-icon bi bi-bar-chart-line" />{" "}
                      <span className="menu-name">Other Reports</span>
                  </a>
                  {openMenus.other && (
                  <div className='dropdown-menu show' style={{position: "absolute", inset: "0px auto auto 0px", margin: "0px 25px", transform: "translate(0px, 48px)"}}>
                      <div className="nav-item">
                          <Link to="/bbps-report" className="nav-link" exact component={BBPS}>
                              <span className="menu-name">&nbsp;&nbsp;BBPS Report</span>
                          </Link>
                      </div>
                      <div className="nav-item">
                          <Link to="/lic-report" className="nav-link" exact component={LicReport}>
                              <span className="menu-name">&nbsp;&nbsp;LIC Report</span>
                          </Link>
                      </div>
                      <div className="nav-item">
                          <span className="nav-link">                              
                              <span className="menu-name">&nbsp;&nbsp;Fastag Report</span>
                          </span>
                      </div>
                      <div className="nav-item">
                          <Link to="/cms-report" className="nav-link" exact component={CmsReport}>
                              <span className="menu-name">&nbsp;&nbsp;Cms Report</span>
                          </Link>
                      </div>
                      <div className="nav-item">
                          <span className="nav-link">                              
                              <span className="menu-name">&nbsp;&nbsp;Dmt Kyc Report</span>
                          </span>
                      </div>
                      <div className="nav-item">
                          <span className="nav-link">                              
                              <span className="menu-name">&nbsp;&nbsp;Aadhar Kyc Report</span>
                          </span>
                      </div>
                      <div className="nav-item">
                          <Link to="/wallet-to-wallet-report" className="nav-link" exact component={WalletToWalletReport}>
                              <span className="menu-name">&nbsp;&nbsp;Wallet To Wallet</span>
                          </Link>
                      </div>                            
                  </div>
                  )}
              </li>
              <li className="nav-item fw-500 dropdown">
                  <a
                      href="#"
                      className="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      onClick={() => toggleMenu("ledger")}
                  >
                      <i className="menu-icon bi bi-border-width" />
                      <span className="menu-name">Ledger</span>
                  </a>
                  {openMenus.ledger && (
                  <div className='dropdown-menu show' style={{position: "absolute", inset: "0px auto auto 0px", margin: "0px 25px", transform: "translate(0px, 48px)"}}>
                      <div className="nav-item">
                          <Link to="/refund-pending-report" className="nav-link" exact component={RefundPendigReport}>
                              <span className="menu-name">&nbsp;&nbsp;Refund Pending</span>
                          </Link>
                      </div>
                      <div className="nav-item">
                          <span className="nav-link">                              
                              <span className="menu-name">
                                  &nbsp;&nbsp;Approve Return Request
                              </span>
                          </span>
                      </div>
                      <div className="nav-item">
                          <span className="nav-link">                              
                              <span className="menu-name">&nbsp;&nbsp;Transaction Summary</span>
                          </span>
                      </div>
                      <div className="nav-item">
                        <Link to="/account-statement-report" className="nav-link" exact component={AccountStatementReport}>&nbsp;&nbsp;Account Statement</Link>
                      </div>
                      <div className="nav-item">
                          <span className="nav-link">                              
                              <span className="menu-name">&nbsp;&nbsp;Comm. Statement</span>
                          </span>
                      </div>
                      <div className="nav-item">
                          <span className="nav-link">                              
                              <span className="menu-name">&nbsp;&nbsp;Aeps Statement</span>
                          </span>
                      </div>
                      <div className="nav-item">
                          <Link to="/settlement-report" className="nav-link" exact component={SettlementReport}>
                              <span className="menu-name">&nbsp;&nbsp;Settlement Report</span>
                          </Link>
                      </div>
                      <div className="nav-item">
                          <span className="nav-link">                              
                              <span className="menu-name">&nbsp;&nbsp;Debit Credit Report</span>
                          </span>
                      </div>
                  </div>
                  )}
              </li>                    
          </ul>
          <h6 className="fw-medium align-self-center">
              Your <span id="roleT" />
          </h6>
          <div
              style={{
                  background:
                      "radial-gradient(circle at 10% 20%, rgb(255 202 25) 0%, rgb(0 168 243) 90%)"
              }}
          >
              <h6 className="p-2">
                  <span>
                      <span className="roleT" /> Name : <span className="parentN" />
                  </span>
                  <br />
                  <span>
                      <span className="roleT" /> Mobile : <span className="parentM" />
                  </span>
              </h6>
          </div>
          <h6 className="fw-medium align-self-center">What's App Support</h6>
          <div
              style={{
                  background:
                      "radial-gradient(circle at 10% 20%, rgb(255 202 25) 0%, rgb(0 168 243) 90%)"
              }}
          >
              <h6 className="p-2">
                  <span>
                      <img
                          src="/images/WhatsApp Image 2025-01-11 at 19.15.12.jpeg"
                          style={{ height: 30 }}
                      />{" "}
                      +91 9560-416-480
                  </span>
              </h6>
          </div>
          <h6 className="fw-medium align-self-center">Support Number</h6>
          <div
              style={{
                  background:
                      "radial-gradient(circle at 10% 20%, rgb(255 202 25) 0%, rgb(0 168 243) 90%)"
              }}
          >
              <h6 className="p-2">
                  <span>
                      C Care : 9560-416-480
                      <br />{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9560-416-494
                  </span>
                  <br />
                  <span>Email : support@kiaraapay.com</span>
              </h6>
          </div>
          <div className="mt-auto" />
      </div>
  </div>
    );
}

export default Sidebar;